<template>
  <Layout>
    <div class="page-container">
      <div class="_mc-list-header">
        <PageHeader :title="title" subTitle="">
          <template #afterTitle>
            <McButtonBack />
          </template>
        </PageHeader>
      </div>

      <b-card>
        <b-table class="__table" :fields="fields" :items="items" :busy="isLoading" show-empty>
          <!-- Loading -->
          <template #table-busy>
            <div class="__busy">
              <b-spinner class="align-middle mb-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <!-- Empty Result -->
          <template #empty>
            <div class="text-center my-4">Tidak ada data</div>
          </template>

          <template #cell(addendum)="{ item }">
            <router-link
              :to="{
                name: 'Master Vendor Contract Detail',
                params: { ...$route.params, versionId: item.id },
              }"
              class="__version"
            >
              v.{{ item.addendum }} {{ item.status == 'aktif' ? '(Aktif)' : '' }}
            </router-link>
          </template>

          <template #cell(created_on)="{ item }">
            <div class="__created-on">
              <div class="__date">{{ formatIndexDate(item.created_on).date }}</div>
              <div class="__time">{{ formatIndexDate(item.created_on).time }}</div>
            </div>
          </template>
        </b-table>
      </b-card>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McButtonBack from '@/components/McButtonBack'

import { formatIndexDate } from '@/helpers/tzDate'

import * as Addendum from '@/services/rest-api/lib/contract/addendum'

export default {
  title: 'Master Vendor Contract Form',
  meta: [{ name: 'description', content: appConfig.description }],
  components: {
    Layout,
    PageHeader,
    McButtonBack
  },
  data() {
    return {
      title: 'Riwayat Addendum',
      items: [],
      isLoading: true,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'addendum',
          label: 'Versi Addendum',
          isRedirectable: true,
        },
        {
          key: 'created_on',
          label: 'Tanggal Addendum',
        },
        {
          key: 'created_by',
          label: 'Dibuat Oleh',
        },
        {
          key: 'reason',
          label: 'Alasan Addendum',
        },
      ]
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
      }
    },
  },
  async mounted() {
    const res = await Addendum.getHistory(this.$route.params)

    if (!res || res.errors) {
      this.$mcToast.error('Gagal menggambil riwayat')
      this.isLoading = false
      return
    }

    this.items = res.data
    this.isLoading = false
  },
  methods: {
    formatIndexDate,
    handleClickRow(item) {
      this.$router.push({
        name: 'Master Vendor Contract Detail',
        params: { ...this.$route.params, versionId: item?.id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/addendum-history.scss';
</style>
